import { useState } from 'react';

const CollectionModals = () => {

  const [collectionCreateModal, setCollectionCreateModal] = useState(null);
  const [collectionEditModal, setCollectionEditModal] = useState(null);
  const [collectionImportModal, setCollectionImportModal] = useState(null);
  const [columnCreateModal, setColumnCreateModal] = useState(null);
  const [columnEditModal, setColumnEditModal] = useState(null);
  const [settingsModal, setSettingsModal] = useState(null);
  const [permissionModal, setPermissionModal] = useState(null);

  const onClickOpenCollectionCreateModal = () => 
		setCollectionCreateModal({ visible: true });

	const onClickCloseCollectionCreateModal = () => 
		setCollectionCreateModal(null);

	const onClickOpenCollectionEditModal = () =>
		setCollectionEditModal({ visible: true });

	const onClickCloseCollectionEditModal = () =>
		setCollectionEditModal(null);

	const onClickOpenCollectionImportModal = () =>
		setCollectionImportModal({ visible: true });

	const onClickCloseCollectionImportModal = () =>
		setCollectionImportModal(null);

	const onClickOpenColumnCreateModal = () =>
		setColumnCreateModal({ visible: true });

	const onClickCloseColumnCreateModal = () =>
		setColumnCreateModal(null);

	const onClickOpenColumnEditModal = (columnName) =>
		setColumnEditModal({ visible: true, columnName });

	const onClickCloseColumnEditModal = () =>
		setColumnEditModal(null);

	const onClickOpenSettingsModal = () =>
		setSettingsModal({ visible: true });

	const onClickCloseSettingsModal = () =>
		setSettingsModal(null);

	const onClickOpenPermissionModal = () =>
		setPermissionModal({ visible: true });

	const onClickClosePermissionModal = () =>
		setPermissionModal(null);

  return {
    collectionCreateModal,
    collectionEditModal,
    collectionImportModal,
    columnCreateModal,
    columnEditModal,
    settingsModal,
    permissionModal,
    onClickOpenCollectionCreateModal,
    onClickCloseCollectionCreateModal,
    onClickOpenCollectionEditModal,
    onClickCloseCollectionEditModal,
    onClickOpenCollectionImportModal,
    onClickCloseCollectionImportModal,
    onClickOpenColumnCreateModal,
    onClickCloseColumnCreateModal,
    onClickOpenColumnEditModal,
    onClickCloseColumnEditModal,
    onClickOpenSettingsModal,
    onClickCloseSettingsModal,
    onClickOpenPermissionModal,
    onClickClosePermissionModal
  }

}

export { 
  CollectionModals
}